import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/hooks/redux";
import { RenderFormFields } from "src/components/RenderFormFields";
import { selectCountriesWithInterner } from "src/redux/countries/selectors";
import { StepControls } from "../StepControls";
import { getReprecentionCountriesField } from "../constants/fields";
import { registrationTitlesTrns } from "../trns";
import { StepControlsProps } from "../types";

interface Props extends StepControlsProps {}

export const WhereProductsRepresented: FC<Props> = ({
  ...stepControlsProps
}) => {
  const { t } = useTranslation();
  const { items: countriesWithInterner } = useAppSelector(
    selectCountriesWithInterner // countries options and internet option together
  );
  const reprecentionCountriesField = getReprecentionCountriesField(
    countriesWithInterner
  );

  return (
    <div className="flex flex-col gap-10">
      <div className="flex flex-col gap-5 md:gap-10">
        <h2 className="font-semibold">
          {t(registrationTitlesTrns.countriesOfRepresentation)}
        </h2>

        <div>
          <RenderFormFields fields={reprecentionCountriesField} />
        </div>
      </div>
      <StepControls {...stepControlsProps} />
    </div>
  );
};
